import { Rule } from "@rumble-it/common-lib/types/models/Rule.interface";
import { UseMutationResult } from "@tanstack/react-query";
import { Button, Card, Input, Select } from "@rumbledirect/ui";
import { Form, InputNumber, Switch } from "antd";

interface RuleFormCardProps {
  mutation: UseMutationResult<Rule, Error, Rule, unknown>;
  loading?: boolean;
  initialValues?: Rule;
  title?: string;
  buttonText?: string;
}

export const RuleFormCard = ({
  mutation,
  loading,
  initialValues,
  title = "Regel Aanmaken",
  buttonText = "Aanmaken",
}: RuleFormCardProps) => {
  return (
    <Card loading={loading} title={title}>
      <Form
        onFinish={mutation.mutate}
        layout="vertical"
        initialValues={initialValues}
      >
        <Form.Item
          rules={[{ required: true, message: "Dit veld is verplicht." }]}
          label="Naam"
          name="name"
        >
          <Input />
        </Form.Item>
        <Form.Item label="Beschrijving" name="description">
          <Input.TextArea />
        </Form.Item>
        <Form.Item
          name="conditionMatcher"
          label="Conditie Matcher"
          rules={[
            { required: true, message: "Selecteer een conditie matcher" },
          ]}
        >
          <Select
            options={[
              {
                value: "all",
                label: "Alle condities",
              },
              {
                value: "any",
                label: "Een van de condities",
              },
            ]}
          />
        </Form.Item>
        <Form.Item
          name="eventName"
          label="Event"
          rules={[{ required: true, message: "Event is verplicht" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Prioriteit"
          name="priority"
          rules={[{ required: true, message: "Prioriteit is verplicht" }]}
        >
          <InputNumber className="w-full" />
        </Form.Item>

        <Form.Item label="Actief" name="active" valuePropName="checked">
          <Switch />
        </Form.Item>

        <Form.Item
          label="Stop propagatie"
          name="stopPropagation"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>

        <Form.Item label={null}>
          <Button loading={mutation.isPending} type="primary" htmlType="submit">
            {buttonText}
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
};
